import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { BlogCard } from './BlogCard';
import { CategoryFilter } from './CategoryFilter';
import { SearchBar } from './SearchBar';
import { useBlog } from '../../hooks/useBlog';
import { LoadingSpinner } from '../common/Loading';
import { ErrorMessage } from '../common/Error';

export const BlogPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const { posts, categories, loading, error } = useBlog();

  // CategoryFilter consome nomes; filtro compara com categoryName do post
  const categoryNames = categories.map(category => category.name);

  const filteredPosts = posts.filter(post => {
    const matchesCategory = !selectedCategory || post.categoryName === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)]">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
          <BookOpen className="w-8 h-8 text-purple-300" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-purple-200">Blog</h2>
          <p className="text-purple-300/70">Explore nosso conteúdo sobre astrologia</p>
        </div>
      </div>

      <div className="space-y-6">
        <div className="flex flex-col md:flex-row gap-4">
          <SearchBar value={searchTerm} onChange={setSearchTerm} />
          <CategoryFilter
            categories={categoryNames}
            selectedCategory={selectedCategory}
            onSelect={setSelectedCategory}
          />
        </div>

        {filteredPosts.length === 0 ? (
          <div className="text-center text-purple-200/70 py-8">
            Nenhum post encontrado
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredPosts.map((post) => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};